import FullBlock from "../Block/FullBlock";
import {
    sutdDetails,
    outsideSutdDetails,
    otherDuringUniDetails,
    inIndonesiaDetails,
} from "../../data/leadership";

export default function LeadershipBlock() {
    return (
        <section>
            <div>
                {TitleLists.map((detail) => {
                    const { header, detailsName,logo } = detail;
                    return (
                        <FullBlock
                            header={header}
                            detailsName={detailsName}
                            logo={logo}
                        />
                    )
                })}
            </div>
        </section>

    )
}

const TitleLists = [
    {
        header: "SUTD Extracurriculars",
        detailsName: sutdDetails,
        logo:require("../../images/Commons/sutd.png"),
    },
    {
        header: "Extracurriculars Outside of SUTD",
        detailsName: outsideSutdDetails,
        logo:require("../../images/Leadership/ppis.png"),
    },
    {
        header: "Other Events During Uni",
        detailsName: otherDuringUniDetails,
        logo:require("../../images/Commons/events.png"),
    },

    {
        header: "Back in Jakarta",
        detailsName: inIndonesiaDetails,
        logo:require("../../images/Leadership/tutuwurihandayani.png"),
    },



]
